"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorAttemptsExhaustedViewContainer = void 0;
var _reactRedux = require("react-redux");
var _authentication = require("../../actions/authentication");
var _events = require("../../actions/events");
var _login = require("../../actions/login");
var _selectors = require("./selectors");
var _TwoFactorAttemptsExhaustedViewContainer = require("./TwoFactorAttemptsExhaustedViewContainer");
function mapStateToProps(state) {
  return {
    login: (0, _selectors.loginSelector)(state),
    phone: (0, _selectors.phoneSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    emit(type, event) {
      dispatch((0, _events.emit)(type, event));
    },
    changeLogin(login) {
      dispatch((0, _login.changeLogin)(login));
    },
    reset() {
      dispatch((0, _authentication.reset)());
    }
  };
}
const TwoFactorAttemptsExhaustedViewContainer = exports.TwoFactorAttemptsExhaustedViewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TwoFactorAttemptsExhaustedViewContainer.TwoFactorAttemptsExhaustedViewContainer);